"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.VehiclesCompareSectionReducers = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _actionTypes = require("../actions/action-types");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var initalVehicleCompareState = {
  vehicleList: [],
  vehicleTrimList: [],
  vehicleSelectedList: [],
  modelSelectedList: [],
  currentOrder: 0,
  showVehicleList: {
    stage1: true,
    stage2: false,
    overlayDialog: false
  }
};

var vehicleCompareReducer = function vehicleCompareReducer(state, action) {
  if (state === void 0) {
    state = initalVehicleCompareState;
  }

  var getSelectedVehicleList = function getSelectedVehicleList() {
    var data = state.vehicleTrimList.find(function (vehile) {
      return vehile.code === action.vehicleChosed.vehicleCode;
    });
    data = _objectSpread({}, data);
    data.value = action.vehicleChosed.modelCode;
    return data;
  };

  var getSelectedModels = function getSelectedModels() {
    var vehicleData = state.vehicleList.find(function (vehicle) {
      return vehicle.code === action.vehicleChosed.vehicleCode;
    });
    var modelData = vehicleData.models.find(function (model) {
      return model.code === action.vehicleChosed.modelCode;
    });
    return [modelData];
  };

  var updateSelectedVehicleList = function updateSelectedVehicleList() {
    var item = state.vehicleSelectedList[action.index];
    item.value = action.modelCode;
    return [].concat(state.vehicleSelectedList);
  };

  var deleteSelectedVehicle = function deleteSelectedVehicle() {
    var newVehicleSelectedList = [].concat(state.vehicleSelectedList);
    newVehicleSelectedList.splice(action.index, 1);
    return newVehicleSelectedList;
  };

  var deleteSelectedModel = function deleteSelectedModel() {
    var newModelSelectedList = [].concat(state.modelSelectedList);
    newModelSelectedList.splice(action.index, 1);
    return newModelSelectedList;
  };

  var updateSelectedModelList = function updateSelectedModelList() {
    var vehicleData = state.vehicleList.find(function (vehicle) {
      return vehicle.code === action.vehicleCode;
    });
    var modelData = vehicleData.models.find(function (model) {
      return model.code === action.modelCode;
    });
    var newModelList = [].concat(state.modelSelectedList);
    newModelList[action.index] = _objectSpread({}, modelData);
    return newModelList;
  };

  var updateOrAddSelectedVehicleList = function updateOrAddSelectedVehicleList() {
    var vehicleSelectedCount = state.vehicleSelectedList.length;

    if (state.currentOrder < vehicleSelectedCount) {
      // update
      var _data = state.vehicleTrimList.find(function (vehile) {
        return vehile.code === action.vehicleChosed.vehicleCode;
      });

      _data = _objectSpread({}, _data);
      _data.value = action.vehicleChosed.modelCode;

      var _newVehicleSelectedList = [].concat(state.vehicleSelectedList);

      _newVehicleSelectedList[state.currentOrder] = _data;
      return _newVehicleSelectedList;
    } // add


    var data = state.vehicleTrimList.find(function (vehile) {
      return vehile.code === action.vehicleChosed.vehicleCode;
    });
    data = _objectSpread({}, data);
    data.value = action.vehicleChosed.modelCode;
    var newVehicleSelectedList = [].concat(state.vehicleSelectedList);
    return [].concat(newVehicleSelectedList, [data]);
  };

  var updateOrAddSelectedModelList = function updateOrAddSelectedModelList() {
    var vehicleData = state.vehicleList.find(function (vehicle) {
      return vehicle.code === action.vehicleChosed.vehicleCode;
    });
    var modelData = vehicleData.models.find(function (model) {
      return model.code === action.vehicleChosed.modelCode;
    });
    var newModelList = [].concat(state.modelSelectedList);
    newModelList[state.currentOrder] = _objectSpread({}, modelData);
    return newModelList;
  };

  switch (action.type) {
    case _actionTypes.VEHICLE_TRIM_LIST:
      return _objectSpread(_objectSpread({}, state), {}, {
        vehicleTrimList: action.data.vehicleTrimList
      });

    case _actionTypes.VEHICLE_FULL_LIST:
      return _objectSpread(_objectSpread({}, state), {}, {
        vehicleList: action.data.vehicleList
      });

    case _actionTypes.VEHICLE_SELECTED_LIST:
      return _objectSpread(_objectSpread({}, state), {}, {
        vehicleSelectedList: [].concat(state.vehicleSelectedList, [getSelectedVehicleList()]),
        modelSelectedList: state.modelSelectedList.concat(getSelectedModels())
      });

    case _actionTypes.VEHICLE_UPDATE_OR_ADD:
      return _objectSpread(_objectSpread({}, state), {}, {
        vehicleSelectedList: updateOrAddSelectedVehicleList(),
        modelSelectedList: updateOrAddSelectedModelList()
      });

    case _actionTypes.VEHICLE_UPDATE_MODEL_LIST:
      return _objectSpread(_objectSpread({}, state), {}, {
        vehicleSelectedList: updateSelectedVehicleList(),
        modelSelectedList: [].concat(updateSelectedModelList())
      });

    case _actionTypes.VEHICLE_DELETE:
      return _objectSpread(_objectSpread({}, state), {}, {
        vehicleSelectedList: deleteSelectedVehicle(),
        modelSelectedList: deleteSelectedModel()
      });

    case _actionTypes.VEHICLE_UPDATE_CURRENT_INDEX:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentOrder: action.index
      });

    case _actionTypes.VEHICLE_LIST_SHOW_HIDE:
      return _objectSpread(_objectSpread({}, state), {}, {
        showVehicleList: action.flag
      });

    case _actionTypes.VEHICLE_LIST_RESET:
      return _objectSpread(_objectSpread({}, state), {}, {
        vehicleSelectedList: [],
        modelSelectedList: [],
        currentOrder: 0,
        showVehicleList: {
          stage1: true,
          stage2: false,
          overlayDialog: false
        }
      });

    default:
      return state;
  }
}; // eslint-disable-next-line import/prefer-default-export


var VehiclesCompareSectionReducers = {
  vehicleCompare: vehicleCompareReducer
};
exports.VehiclesCompareSectionReducers = VehiclesCompareSectionReducers;